import { render, staticRenderFns } from "./PitstopPeopleA.vue?vue&type=template&id=49f48572&scoped=true&"
import script from "./PitstopPeopleA.vue?vue&type=script&lang=js&"
export * from "./PitstopPeopleA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f48572",
  null
  
)

export default component.exports